/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-08.
 * Pagination component
 */
import React, { Component } from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FirstPage from 'material-ui/svg-icons/navigation/first-page';
import LastPage from 'material-ui/svg-icons/navigation/last-page';
import Previous from 'material-ui/svg-icons/navigation/chevron-left';
import Next from 'material-ui/svg-icons/navigation/chevron-right';
import { range as getRange, omit } from 'lodash';

function getVisibleRange(position, length, radius) {
    const pos = position + 1;
    let left = Math.max(pos - radius, 1);
    const right = Math.min(left + (2 * radius), length);
    const span = right - left;
    if (span < 2 * radius) { left = Math.max(right - (2 * radius), 1); }
    return getRange(left, right + 1);
}

function notifyChange(ev, ind, props) {
    ev.preventDefault();
    const page = ind - 1;
    if (props.notify) {
        props.notify(page);
    }
}

class Pagination extends Component {
    render() {
        const { activePage, numPages, notify, radius = 2 } = this.props;
        const range = getVisibleRange(activePage, numPages, radius);
        const activeButtonConfig = { backgroundColor: '#0277bd', textStyle: { color: '#FFF' } };
        const normalButtonConfig = { backgroundColor: '#FFF', iconStyle: { fill: '#4d5156' } };

        return (
            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', overflowX: 'auto', paddingBottom: '0.5rem' }}>
                <FloatingActionButton
                    style={{ marginleft: '1rem', marginRight: '1rem' }}
                    mini
                    {...normalButtonConfig}
                    disabled={activePage === 0}
                    onTouchTap={(event) => notifyChange(event, 1, { notify })}
                >
                    <FirstPage />
                </FloatingActionButton>

                <FloatingActionButton
                    mini
                    style={{ marginleft: '1rem', marginRight: '1rem' }}
                    {...normalButtonConfig}
                    disabled={activePage === 0}
                    onTouchTap={(event) => notifyChange(event, activePage, { notify })}
                >
                    <Previous />
                </FloatingActionButton>
                {
                    range.map((e, i) => {
                        const config = (e - 1) === activePage ?
                            activeButtonConfig : normalButtonConfig;
                        return (
                            <FloatingActionButton
                                mini
                                style={{ marginleft: '1rem', marginRight: '1rem' }}
                                key={i}
                                {...omit(config, ['textStyle'])}
                                onTouchTap={(event) => notifyChange(event, e, { notify })}
                            >
                                <label
                                    htmlFor
                                    style={config.textStyle || { color: '#000' }}
                                >
                                    {e}
                                </label>
                            </FloatingActionButton>
                        );
                    })
                }
                <FloatingActionButton
                    mini
                    style={{ marginleft: '1rem', marginRight: '1rem' }}
                    {...normalButtonConfig}
                    disabled={numPages === activePage + 1}
                    onTouchTap={(event) => notifyChange(event, (activePage + 2), { notify })}
                >
                    <Next />
                </FloatingActionButton>
                <FloatingActionButton
                    mini
                    style={{ marginleft: '1rem', marginRight: '1rem' }}
                    {...normalButtonConfig}
                    disabled={numPages === activePage + 1}
                    onTouchTap={(event) => notifyChange(event, numPages, { notify })}
                >
                    <LastPage />
                </FloatingActionButton>
            </div>
        );
    }
}

export default Pagination;



// WEBPACK FOOTER //
// ./components/widgets/pagination.js